import {DataTypeConstraintCreateDto, DataTypeConstraintDto} from "./DataTypeConstraintDto";


export interface DataTypeDefinitionDto {
    id: string;
    name: string;
    description?: string;
    coreDataType: CoreDataType;
    constraints?: DataTypeConstraintDto[];
    acl?: DataTypeDefinitionAclDto;
}

export enum CoreDataType {
    STRING = "STRING",
    INTEGER = "INTEGER",
    FLOAT = "FLOAT",
    CURRENCY = "CURRENCY",
    BOOLEAN = "BOOLEAN",
    DATE = "DATE",
    TIME = "TIME",
    DATETIME = "DATETIME",
}

export interface DataTypeDefinitionAclDto {
    canUpdate: boolean;
    canDelete: boolean;
    canCreateConstraints: boolean;
}

export interface DataTypeDefinitionCreateDto {
    name: string;
    description?: string;
    coreDataType: CoreDataType;
    constraints?: DataTypeConstraintCreateDto[];
}

export interface DataTypeDefinitionUpdateDto {
    name: string;
    description?: string;
}